export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/godaddy.657f986.svg";